import { render } from "./Aside.vue?vue&type=template&id=664ddef4"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=664ddef4&scope=true&lang=scss"
script.render = render

export default script